import styled from "styled-components";

export const DescriptionBold = styled.span`
  ${({ theme }) => theme.smartphone} {
    font-weight: bold;
  }
`;
